<template>
    <div class="managePreparencePopup">
      <div class="col-sm-12 col-xs-12 col-md-12 p-0">
        <hr class="header-line" />
      </div>
      <div class="col-sm-12 col-xs-12 pl-0 body" v-if="!editAddress">
        <div class="d-flex pl-34  pr-43 flex-between" >
          <div class=""><span class="profile-details">{{$t('profileDetails')}}</span></div>
          <div v-if="roleId === 1 || roleId===roleInfo['Super Admin']" class="pt-4"> <button type="button" class="btn add_address_button" @click="addAddress()">  <img class="cursor-pointer mb-2 pr-8" src="/static/images/icons/Add.svg" alt="download-icon" /><span class="pl-8">{{ $t('addAddress') }}</span>
              </button></div>
        </div>
         <div class="col-sm-6 col-md-6 col-xs-12 pl-41">
          <div class="row">
            <div class="col-sm-12 col-xs-12 form_label_name">{{$t('cnpj')}} <span class="required">*</span></div>
            <div class="col-sm-12 col-xs-12 field_css xs-mr-bt-0">
              <input
                :disabled="true"
                type="text"
                class="form-control"
                :class="$v.company.cnpj.$error ? 'invalid-border':''"
                maxlength="35"
                v-model.trim="company.cnpj"
                @keyup="checkUpdatedFields"
                @blur="$v.company.cnpj.$touch()"
                :readonly="checkRole"
              />
              <div v-if="$v.company.cnpj.$error">
                <div
                  class="custom-error-text"
                  v-if="!$v.company.cnpj.required"
                >{{$t('completeRequiredField')}}</div>
                <!-- <div
                  class="custom-error-text"
                  v-else-if="!$v.company.cnpj.minLength"
                >{{$t('min2CharactersRequired')}}</div>
              </div> -->
            </div>
            <div
                            class="custom-error-text"
                            v-else-if="company.cnpj&&isValidCnpj==='invalid'"
                          >{{$t('invalidCnpjNumber')}}</div>
                          <div
                            class="custom-success-class"
                            v-else-if="company.cnpj&&isValidCnpj==='valid'"
                          >{{$t('validCnpjNumber')}}</div>
                        </div>
                <div class="col-sm-12 col-xs-12 form_label_name">{{$t('companyName')}}  <span class="required">*</span></div>
            <div class="col-sm-12 col-xs-12 xs-mr-bt-0" :class="{'field_css':!$v.company.company.$error}" >
              <input
                type="text"
                class="form-control"
                :class="[$v.company.company.$error ? 'invalid-border':'', companyExists ? 'warning-border': '', checkRole?'cursor-not-allowed':'']"
                maxlength="50"
                v-model.trim="company.company"
                @blur="$v.company.company.$touch(); companyExists=false"
                @input="checkUpdatedFields"
                :readonly="checkRole"
              />
              <div v-if="$v.company.company.$error">
                <div
                  class="custom-error-text"
                  v-if="!$v.company.company.required"
                >{{$t('completeRequiredField')}}</div>
                <div
                  class="custom-error-text"
                  v-else-if="!$v.company.company.minLength"
                >{{$t('min2CharactersRequired')}}.</div>
                <div
                  class="custom-error-text"
                  v-else-if="!$v.company.company.isAlphaNum"
                >{{$t('firstCharacterShouldBeAlphaNumeric')}}</div>
              </div>
              <div v-if="companyExists">
                <div
                  class="custom-warning-class"
                >{{$t('companyAlreadyExists')}}.</div>
              </div>
            </div>
            <div class="col-sm-12 col-xs-12 form_label_name">{{$t('streetAddress')}}  <span class="required">*</span></div>
            <div class="col-sm-12 col-xs-12  xs-mr-bt-0" :class="{'field_css':!$v.company.street_address.$error}" >
              <input
                type="text"
                class="form-control"
                :class="[$v.company.street_address.$error ? 'invalid-border' : '', checkRole?'cursor-not-allowed':'']"
                size="60"
                v-model.trim="company.street_address"
                @blur="$v.company.street_address.$touch()"
                @keyup="checkUpdatedFields"
                :readonly="checkRole"
              />
              <div v-if="$v.company.street_address.$error">
                <div
                  class="custom-error-text"
                  v-if="!$v.company.street_address.required"
                >{{$t('completeRequiredField')}}</div>
                <div
                  class="custom-error-text"
                  v-if="!$v.company.street_address.isAllowedCharacters && $v.company.street_address.$error"
                >{{ specialCharacterErrMsg }}</div>
              </div>
            </div>
            <div class="col-sm-12 col-xs-12 form_label_name">{{$t('city')}}  <span class="required">*</span></div>
            <div class="col-sm-12 col-xs-12  xs-mr-bt-0" :class="{'field_css':!$v.company.card_city.$error}">
              <input
                type="text"
                class="form-control"
                size="60"
                maxlength="50"
                :class="[$v.company.card_city.$error ? 'invalid-border':'', checkRole?'cursor-not-allowed':'']"
                v-model.trim="company.card_city"
                @blur="$v.company.card_city.$touch()"
                @keyup="checkUpdatedFields"
                :readonly="checkRole"
              />
              <div v-if="$v.company.card_city.$error">
                <div
                  class="custom-error-text"
                  v-if="!$v.company.card_city.required"
                >{{$t('completeRequiredField')}}</div>
                <div
                  class="custom-error-text"
                  v-if="!$v.company.card_city.minLength"
                >{{$t('min3CharactersRequired')}}.</div>
                <div
                  class="custom-error-text"
                  v-else-if="!$v.company.card_city.isAllowedCharacters"
                >{{ specialCharacterErrMsg }}</div>
              </div>
            </div>
            <div class="col-sm-12 col-xs-12 form_label_name">{{$t('state')}}  <span class="required">*</span></div>
            <div class="col-sm-12 col-xs-12  xs-mr-bt-0" :class="{'field_css':!$v.company.card_state.$error}">
              <input
                type="text"
                class="form-control"
                :class="[$v.company.card_state.$error ? 'invalid-border' : '', checkRole?'cursor-not-allowed':'']"
                maxlength="50"
                v-model.trim="company.card_state"
                @blur="$v.company.card_state.$touch()"
                @keyup="checkUpdatedFields"
                :readonly="checkRole"
              />
              <div v-if="$v.company.card_state.$error">
                <div
                  class="custom-error-text"
                  v-if="!$v.company.card_state.required"
                >{{$t('completeRequiredField')}}</div>
                <div
                  class="custom-error-text"
                  v-if="!$v.company.card_state.isAllowedCharacters && $v.company.card_state.$error"
                >{{ specialCharacterErrMsg }}</div>
              </div>
            </div>
            <div class="col-sm-12 col-xs-12 form_label_name">{{$t('postCode')}}  <span class="required">*</span></div>
            <div class="col-sm-12 col-xs-12  xs-mr-bt-0" :class="{'field_css':!$v.company.card_postal.$error}">
              <input
                type="text"
                class="form-control"
                maxlength="15"
                :class="[$v.company.card_postal.$error ? 'invalid-border':'', checkRole?'cursor-not-allowed':'']"
                v-model.trim="company.card_postal"
                @blur="$v.company.card_postal.$touch()"
                @keyup="checkUpdatedFields"
                :readonly="checkRole"
              />
              <div v-if="$v.company.card_postal.$error">
                <div
                  class="custom-error-text"
                  v-if="!$v.company.card_postal.required"
                >{{$t('completeRequiredField')}}</div>
                <div
                  class="custom-error-text"
                  v-if="!$v.company.card_postal.minLength"
                >{{$t('min2CharactersRequired')}}.</div>
                <div
                  class="custom-error-text"
                  v-else-if="!$v.company.card_postal.isPostalCode && company.card_postal"
                >{{$t('validZipRequired')}}</div>
              </div>
            </div>
            <div class="col-sm-12 col-xs-12 form_label_name">{{$t('country')}}  <span class="required">*</span></div>
            <div class="col-sm-12 col-xs-12  xs-mr-bt-0" :class="{'field_css':!$v.company.country_name.$error}">
              <multiselect
                class="multiselect-single-dropdown mb-38"
                :placeholder="$t('selectACountry')"
              ref="elCountry"
              @change="checkUpdatedFields"
                label="country_name"
                :showLabels="false"
                openDirection="below"
                v-model="company.country_name"
                :options="countryList.map(type => type.country_name)"
                :custom-label="opt => customLabels(opt)"
                @input="checkUpdatedFields"

                :disabled="checkRole" :class="checkRole?'cursor-not-allowed' : ''"
              >
              <span slot="noResult">{{ $t('noElementsFound') }}</span>
              </multiselect>
              <div v-if="$v.company.country_name.$error">
                <div
                  class="custom-error-text pt-48"
                  v-if="!$v.company.country_name.required && $v.company.country_name.$error"
                >{{$t('completeRequiredField')}}</div>
              </div>
            </div>
            <div class="col-sm-12 col-xs-12 form_label_name">{{$t('companyType')}}  <span class="required">*</span></div>
            <div class="col-sm-12 col-xs-12 field_css xs-mr-bt-0" :class="{'field_css':!$v.company.area_responsible_id.$error}">
              <multiselect
                class="company-type-dropdown multiselect-single-dropdown mb-38"
                :placeholder="$t('companyType')"
              ref="elCountry"
              @change="checkUpdatedFields"
                label="responsibility_name"
                :showLabels="false"
                openDirection="below"
                v-model="company.area_responsible_id"
                :options="responsibilitiesList.map(responsibility => responsibility.id)"
                :custom-label="(opt) => responsibilitiesList.find((x) => x.id === opt).responsibility_name || ''"
                @input="checkUpdatedFields"
                :disabled="checkRole" :class="checkRole?'cursor-not-allowed' : ''"
              >
              <span slot="noResult">{{ $t('noElementsFound') }}</span>
              </multiselect>
              <div v-if="$v.company.area_responsible_id.$error">
                <div
                  class="custom-error-text pt-48"
                  v-if="!$v.company.area_responsible_id.required && $v.company.area_responsible_id.$error"
                >{{$t('completeRequiredField')}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 pl-41 pr-84 mb-60" v-if="roleId===1||roleId===2||roleId===3|| roleId===roleInfo['Super Admin']" :class="collapsed?'pb-15':''">

        <div class="addresses">
              <div class=" d-flex align-items-center attachments-panel-child" >

                  <div class="d-flex flex-direction-column col-xs-12 p-0 attachments-card-outer">
                      <p class="address-title">{{$t('savedAddresses')}}</p>
                      <hr  class="address-line "/>

                  </div>

              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 p-0 regulationBackground" >
         <div class="regulation_table" >
        <table class="table table-responsive regulationDataList" >

            <tr class="ul-table-header">

              <th class="wp-63" >
                <div class="tableHeader cursor-pointer" @click="addressDetailsArrow = (-addressDetailsArrow), sortAddresses('addressDetails', addressDetailsArrow)">
                  <div class="header-ellipsis header-title" :title="$t('addressDetails')">{{$t('addressDetails')}}</div>
                  <div class="arrow" :class="addressDetailsArrow === 1 ? 'down-arrow ' : 'up-arrow '"></div>
                </div>
              </th>
              <th>
                <div class="tableHeader cursor-pointer"  @click="addressTypeArrow = (-addressTypeArrow), sortAddresses('addressType', addressTypeArrow)">
                  <div class="header-ellipsis header-title" :title="$t('addressDetails')">{{$t('addressType')}}</div>
                  <div class="arrow" :class="addressTypeArrow === 1 ? 'down-arrow ' : 'up-arrow '"></div>
                </div>
              </th>
              <th></th>

            </tr>
            <div v-if="multiPlantAddresses.length === 0" class="no-records-found">
              <p>{{$t('noAddressesAdded')}}</p>
        </div>

          <tbody  v-else ref="tbodyBox" >
            <tr class="viewRegistration"
            :class="index%2===0?'table_data_part1':'table_data_part2'"
            v-for="(address, index) in multiPlantAddresses" :key="index">
            <td  class="ellipsis wp-63" :class="!(editHeadquarterAddress&& address.addressType ==='Headquarter')?'regulation-data':'head-quarter'">
              <!-- <div class="d-flex" v-if="editHeadquarterAddress&& address.addressType ==='Headquarter'">
                       <input
                        type="text"
                        :placeholder="$t('enterHeadquarterAddress')"
                        class="form-control wp-80"
                        :class="!validAddress?'error-class':''"
                        size="60"
                        maxlength="500"
                        v-model.trim="headQuarterDetails"
                        name="Address"
                        @keyup="validateAddress()"
                      />
                      <div class="address-icons">
                         <button class="btn btn-delete-address p-0"  :disabled="!validAddress" @click="updateHeadQuarterAddress()">
                          <img src="/static/images/icons/check.svg" class="save" /></button>
                      <img src="/static/images/icons/danger_close_icon.svg" class="save cursor-pointer" @click="headQuarterDetails=address.addressDetails,cancelUpdateAddress()" />
                      </div>
                      </div> -->

                      <div  v-if="!(editHeadquarterAddress&& address.addressType ==='Headquarter')" class=" ellipsis pl-0" :title="address.addressDetails">{{address.addressDetails}}</div>
            </td>

              <td  class="ellipsis regulation-data"><span v-if="address.plantLocationId" :title="$t('plantLocation')">{{ $t('plantLocation') }}</span>
                <!-- <span v-else >{{$t('headquarter')}}</span> -->
              </td>
              <td class="ellipsis edit-icons ">
                <div class=" d-flex justify-content-end pr-0" v-if="roleId === 1|| roleId===roleInfo['Super Admin']"> <div>
                            <button :class="{'pr-44': address.addressType ==='Headquarter'}" class="btn btn-delete-address pr-0 action-icons"  :disabled="address.isUsed"  :title="address.isUsed?$t('addressTitle'):''" data-toggle="tooltip" data-placement="top"  @click="addAddress('edit',address)">
                               <img src="/static/images/icons/EditAddress.svg" class="address-images"  />
                            </button>

                             <button v-if="address.addressType !=='Headquarter'" class="btn btn-delete-address pr-0 action-icons" :disabled="address.isUsed"  :title="address.isUsed?$t('addressTitle'):''" @click="openDeleteConfirmationPopup('address',address.plantLocationId)">
                            <img  src="/static/images/icons/Trash.svg" class="address-images" /></button>
                      </div></div>
              </td>

             </tr>
          </tbody>
        </table>

         </div>
          </div>
            </div>
        </div>
      </div>
      <div class="footer d-flex col-xs-12 col-sm-12 justify-content-end d-flex-sm-end pr-0 pl-0" v-if="!editAddress">
        <div v-show="roleId === 1" class="col-sm-6">
            <button type="button" class="deactivate_button_button" @click="openDeleteConfirmationPopup"
               >{{$t('deactivateAccount')}} </button>
        </div>
        <div class="col-sm-6 pr-0 col-gap-16  d-flex buttons">
        <button type="button" class="btn cancel_button"
          @click="goToDashboard()">{{$t('cancel')}} </button>
          <button type="button" class="btn  save_changes_button" @click="updateCompanyProfile"
              :disabled="checkInvalidData() || disableButtonForCompanyProfile">{{$t('save')}} </button>
        </div>
      </div>

      <loader :loadingStatus="loaderStatus"></loader>
      <div id="confirmPopup" class="modal fade" role="dialog">
        <div class="modal-dialog profile-confirm-poup">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header confirmpopup-bgcolor">
              <button
                type="button"
                class="close"
                data-toggle="modal"
                data-target="#confirmPopup"
              >&times;</button>
            </div>
            <div
              class="modal-body confirm-body"
            >{{ $t('saveChangesMessage')}}</div>
            <div class="modal-footer confirmpopup-bgcolor">
              <div class="col-md-6 col-sm-6 col-xs-12 profile-footer-save">
                <button
                  type="button"
                  class="btn btn-block save-changes"
                  @click="confirmChanges"
                >{{ $t('saveChanges')}}</button>
              </div>
              <div class="col-md-6 col-sm-6 col-xs-12">
                <button
                  type="button"
                  class="btn btn-block discard-changes"
                  @click="cancelConfirmPopUp"
                >{{ $t('discardChanges')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <delete-popup :deletewarnInfo="deleteWarningInfo" :deactivateAccount="!this.deletionId?true:false" :deleteMember="this.deletionId?true:false" :headerTitle="$t('deleteAddress')"
        @dashboardPublishDelete="deactivateAccount()" @closePopup="closePopup">
      </delete-popup>
      <template v-if="editAddress">
        <edit-address @cancelEditAddress="cancelEditAddress" @updateAddress="updateAddress" :isEdit="isEdit" :formData="editData" :mode="mode"></edit-address>
      </template>
    </div>
  </template>

<script>
import $ from 'jquery';
import { required, minLength } from 'vuelidate/lib/validators';
import DeletePopup from '../UIComponents/DeleteRegHeadlinePopup.vue';
import EventBus from '../../utils/event-bus';
import {
  isAllowedCharacters,
  isAlphaNum,
  isPostalCode,
} from '../Register/validator';

import { updateCompanyProfileData, getCompanyProfileData, deactivateAccount } from '../../apis/profile';
import { GetResponsibilities, checkCompanyName, checkCnpj } from '../../apis/register';
import { getAllCountries } from '../../apis/countriesList';
import Loader from '../UIComponents/Loader.vue';
import EditAddress from './EditAddress.vue';
import {
  getMultiplantAddress, deleteAddress,
} from '../../apis/multiplantAddress';

export default {
  props: {
    isEdit: Boolean,
    roleInfo: Object
  },
  components: {
    Loader,
    DeletePopup,
    EditAddress,
  },
  data() {
    return {
      editHeadquarterAddress: false,
      headQuarterDetails: '',
      deletionId: '',
      editAddress: false,
      addressDetailsArrow: 1,
      addressTypeArrow: 1,
      company: {
        cnpj: '',
        company: '',
        street_address: '',
        card_city: '',
        card_state: '',
        card_postal: '',
        country_name: '',
        area_responsible_id: '',
      },
      responsibilitiesList: [],
      countryList: [],
      disableButtonForCompanyProfile: true,
      specialCharacterErrMsg: 'The following characters are not allowed: * ? < > ! @ # $ “ % ^',
      companyExists: false,
      loaderStatus: false,
      closeBasePopup: 'default',
      roleId: JSON.parse(localStorage.getItem('userData')).role_id,
      deleteWarningInfo: {
        loaderStatus: false,
        title: this.$i18n.locale === 'Portuguese' ? 'Esta conta será desativada' : 'This Account will be Deactivated',
      },
      addresses: [{ name: 'P.O. Box 283 8562 Fusce Rd.Frederick Nebraska 20620', type: 'Headquarter' }, { name: 'Box 283 8562 Fusce Rd.Frederick Nebraska 20620dd', type: 'Plant Location' }],
      multiPlantAddresses: [],
      headQuarterAddresses: [],
      mode: '',
      validAddress: true,
      collapsed: true,
      isValidCnpj: '',
      editData: '',
      companyData: ''
    };
  },
  validations: {
    company: {
      cnpj: {
        minLength: minLength(2),
        required,
      },
      company: {
        minLength: minLength(2),
        isAlphaNum,
        required,
      },
      street_address: {
        required,
        isAllowedCharacters,
      },
      card_city: {
        minLength: minLength(3),
        required,
        isAllowedCharacters,
      },
      card_state: {
        required,
        isAllowedCharacters,
      },
      card_postal: {
        minLength: minLength(2),
        required,
        isPostalCode,
      },
      country_name: {
        required,
      },
      area_responsible_id: {
        required,
      },
    },
  },
  computed: {
    checkRole() {
      return this.roleId === 2 || this.roleId === 3 || this.roleId === this.roleInfo['RA Viewer'];
    },
  },
  methods: {
    goToDashboard() {
      this.$emit('closepopup', 'closeBasePopup');
      this.$router.push('/layout/dashboard');
    },
    customLabels(opt) {
      const option = this.countryList.find((x) => x.country_name === opt);
      if (option && Object.keys(option) && Object.keys(option).length) {
        return option.country_name;
      }
      return '';
    },
    async validateCnpj() {
      if (this.company.cnpj) {
        this.loaderStatus = true;
        const response = await checkCnpj(this.company.cnpj);
        this.loaderStatus = false;
        if (response.status === 200) {
          this.isValidCnpj = 'valid';
        } else { this.isValidCnpj = 'invalid'; }
      }
    },
    /* validateAddress() {
      const regex = /^[^*?<>!@#$“%^]*$/;
      this.validAddress = regex.test(this.headQuarterDetails);

      return this.validAddress;
    },
    async updateHeadQuarterAddress() {
      this.loaderStatus = true;
      const response = await updateHeadquarterAddress({ addressDetails: this.headQuarterDetails });
      if (response.status_code === 200) {
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Endereço atualizado' : 'Address updated',
          text: this.$i18n.locale === 'Portuguese' ? 'O endereço foi atualizado com sucesso.' : 'Address was successfully updated.',
          group: 'custom-notification',
        });
        const result = await getHeadQuarterAddress();
        this.multiPlantAddresses[0] = { ...result.data[0] };
        this.loaderStatus = false;
        this.editHeadquarterAddress = false;
      }
    },
    cancelUpdateAddress() {
      this.editHeadquarterAddress = false;
    }, */
    closePopup() {
      this.deletionId = '';
    },

    async updateAddress() {
      // this.editHeadquarterAddress = false;
      this.loaderStatus = true;
      EventBus.$emit('updatePlantLocation');
      this.cancelEditAddress();
      // await this.getHeadquarterAddresses();
      await this.getMultiplantAddresses();
      this.loaderStatus = false;
    },
    async getMultiplantAddresses() {
      const result = await getMultiplantAddress();
      if (result.status_code === 200) {
        this.multiPlantAddresses = result.data;
      } else {
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: result.data,
          group: 'custom-notification',
        });
      }
      console.log(result);
      if (this.multiPlantAddresses.length) {
        this.multiPlantAddresses.forEach((item) => {
          item.addressDetails = `${item.streetAddress} ${item.city} ${item.state} ${item.country} ${item.postCode}`;
          item.addressType = 'Plant Location';
        });
      }
      /* if (this.headQuarterAddresses.length) {
        this.multiPlantAddresses.unshift(this.headQuarterAddresses[0]);
      } */
    },
    /* async getHeadquarterAddresses() {
      const result = await getHeadQuarterAddress();
      console.log(result);
      if (result.status_code === 200) {
        this.headQuarterAddresses = result.data;
        this.headQuarterDetails = result.data[0].addressDetails;
      } else {
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: result.data,
          group: 'custom-notification',
        });
      }
    }, */
    async cancelEditAddress() {
      this.$emit('emitBreadCrumb', '');
      // this.editHeadquarterAddress = false;
      this.editAddress = false;
      // this.headQuarterDetails = this.headQuarterAddresses[0].addressDetails;
    },
    updateHeaderName() {
      this.$emit('emitBreadCrumb', '');
    },
    addAddress(type, data) {
      if (data && data.addressType === 'Headquarter') {
        this.editHeadquarterAddress = true;
        return;
      }
      this.editAddress = true;
      this.editData = data;
      this.mode = type;
      this.$emit('emitBreadCrumb', type === 'edit' ? 'Edit Address' : 'Add Address');
    },
    async deleteAddress() {
      $('#modal_delete').modal('hide');
      this.loaderStatus = true;
      const response = await deleteAddress(this.deletionId);
      if (response.status_code === 200) {
        this.deletionId = '';
        this.clearNotifcations();
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: this.$i18n.locale === 'Portuguese' ? 'Endereço excluído com sucesso' : 'Address deleted successfully',
          group: 'custom-notification',
        });
        EventBus.$emit('updatePlantLocation');
        await this.getMultiplantAddresses();
        this.loaderStatus = false;
      } else {
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: response.data,
          group: 'custom-notification',
        });
      }
    },
    loadLogOut() {
      socket.removeAllListeners(`alertSaveMultiRegistrationDetails_${localStorage.getItem('userId')}`);
      document.cookie = 'Authorization=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      document.cookie = 'redirect_url=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      localStorage.clear();
      sessionStorage.clear();
      this.$router.push('/login');
    },
    async confirmChanges() {
      $('#confirmPopup').modal('toggle');
      await this.updateCompanyProfile();
    },
    cancelConfirmPopUp() {
      this.disableButtonForCompanyProfile = true;
      $('#confirmPopup').modal('toggle');
      this.company = this.companyData;
      this.$emit('closedConfirmPopup', this.closeBasePopup);
      this.closeBasePopup = 'default';
    },
    toggleConfirmPopUp() {
      // this.closeBasePopup = closeBasePopup;
      $('#confirmPopup').modal('toggle');
    },
    openDeleteConfirmationPopup(type, id) {
      if (type === 'address') {
        this.deleteWarningInfo = {
          loaderStatus: false,
          title: this.$i18n.locale === 'Portuguese' ? 'Este endereço será excluído' : 'This address will be deleted',
        };
        this.deletionId = id;
      } else {
        this.deleteWarningInfo = {
          loaderStatus: false,
          title: this.$i18n.locale === 'Portuguese' ? 'Esta conta será desativada' : 'This Account will be Deactivated',
        };
      }
      $('#modal_delete').modal({
        backdrop: 'static',
        keyboard: false,
      });
    },
    async checkCompanyName() {
      if (!this.$v.company.company.$error) {
        this.companyExists = await checkCompanyName({ company_name: this.company.company });
      }
    },
    async checkUpdatedFields() {
      const response = JSON.parse(localStorage.getItem('companyProfileData'));
      if (response.cnpj === this.company.cnpj) {
        this.isValidCnpj = '';
      }
      if (this.company.cnpj === '' || this.company.company === '' || this.company.street_address === '' || this.company.card_city === '' || this.company.card_state === '' || this.company.card_postal === '' || this.company.country_name === '' || this.company.area_responsible_id === '') {
        this.disableButtonForCompanyProfile = true;
        return;
      }
      if (this.$v.company.$invalid) {
        this.disableButtonForCompanyProfile = true;
        return;
      }
      if ((response.cnpj !== this.company.cnpj)
        || response.company !== this.company.company
        || response.street_address !== this.company.street_address
        || response.card_city !== this.company.card_city
        || response.card_state !== this.company.card_state
        || response.card_postal !== this.company.card_postal
        || response.country_name !== this.company.country_name
        || response.area_responsible_id !== this.company.area_responsible_id) {
        this.disableButtonForCompanyProfile = false;
        return;
      }
      this.disableButtonForCompanyProfile = true;
    },
    async getCountryList() {
      this.countryList = await getAllCountries();
    },
    async loadResponsibilites() {
      this.responsibilitiesList = await GetResponsibilities(localStorage.getItem('language'));
    },
    checkInvalidData() {
      if (this.$v.company.$invalid) {
        return true;
      }
      return false;
    },
    async updateCompanyProfile() {
      this.loaderStatus = true;
      const userData = JSON.parse(localStorage.getItem('companyProfileData'));
      if (userData.cnpj !== this.company.cnpj) {
        await this.validateCnpj();
        if (this.isValidCnpj === 'invalid') {
          this.loaderStatus = false;
          return;
        }
      }

      const data = {
        cnpj: this.company.cnpj,
        company: this.company.company,
        street_address: this.company.street_address,
        card_city: this.company.card_city,
        card_state: this.company.card_state,
        card_postal: this.company.card_postal,
        country_name: this.company.country_name,
        area_responsible_id: this.company.area_responsible_id,
      };
      const response = await updateCompanyProfileData(data);
      if (response) {
        this.clearNotifcations();
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: this.$i18n.locale === 'Portuguese' ? 'Perfil da empresa atualizado com sucesso!' : 'Company profile updated successfully!',
          group: 'custom-notification',
        });
        await this.getCompanyProfileData();
        this.disableButtonForCompanyProfile = true;
        this.loaderStatus = false;
        this.isValidCnpj = '';
      }
    },
    async getCompanyProfileData() {
      this.loaderStatus = true;
      this.company = await getCompanyProfileData();
      this.companyData = { ...this.company };
      const companyDataStorage = await getCompanyProfileData();
      if (companyDataStorage) {
        localStorage.setItem('companyProfileData', JSON.stringify(companyDataStorage));
      }
      this.loaderStatus = false;
      EventBus.$emit('updateUserCompanyName', this.company.company);
    },
    clearNotifcations() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },
    async deactivateAccount() {
      if (this.deletionId) {
        this.deleteAddress();
        return;
      }
      const response = await deactivateAccount();
      if (response.status_code === 200) {
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: this.$i18n.locale === 'Portuguese' ? 'Conta desativada com sucesso!' : 'Account deactivated successfully!',
          group: 'custom-notification',
        });
        setTimeout(() => {
          this.clearNotifcations();
          this.loadLogOut();
        }, 700);
      } else {
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: response.data,
          group: 'custom-notification',
        });
      }
    },
    sortAddresses(type, direction) {
      if (direction === 1) this.multiPlantAddresses.sort((a, b) => (a[type] > b[type] ? -1 : 1));
      else {
        this.multiPlantAddresses.sort((a, b) => {
          console.log('dfff', a[type], b[type]);
          const nameA = a[type].toUpperCase(); // ignore upper and lowercase
          const nameB = b[type].toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          // names must be equal
          return 0;
        });
      }
    },
  },
  async created() {
    if (this.isEdit) {
      this.mode = 'add';
      this.$emit('emitBreadCrumb', 'Add Address');
      this.editAddress = this.isEdit;
    } else {
      await this.getCountryList();
      await this.loadResponsibilites();
      await this.getCompanyProfileData();
      // await this.getHeadquarterAddresses();
      await this.getMultiplantAddresses();
    }
  },
  mounted() {
    $('.panel-collapse').on('show.bs.collapse', (e) => {
      console.log('coll[ase]', e);
      this.collapsed = false;
    });
  },
};
</script>

  <style>
  .header-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #3e3e3e;
}

  .deactivate_button_button,
  .deactivate_button_button:hover {
    border-radius: 3px;
    border: none;
    cursor: pointer;
    min-width: 201px;
    font-size: 18px;
    line-height: 25px;
    font-weight: 600;
    padding: 9px 16px;
    background-color: #fff;
    color:#000000;
    border: 1px solid #000001;
    height: 44px;
  }
  .buttons {
    align-items: center;
    justify-content: end !important;
    column-gap: 15px;
    padding-right: 0px;
  }

  .country-select-dropdown .el-input--suffix .el-input__inner {
    border: 1px solid #686E73;
    font-size: 16px;
    color: #2A313A;
  }

  .country-select-dropdown .el-input__suffix .el-input__suffix-inner .el-select__caret.el-input__icon.el-icon-arrow-up::before {
    display: inline-block;
    vertical-align: middle;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #686E73;
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    margin-top: -6px;
    content: '';
  }

  .country-select-dropdown .el-input__suffix .el-input__suffix-inner .el-select__caret.el-input__icon.el-icon-arrow-up.is-reverse {
    position: relative;
    right: 0px;
  }
  .address-icons {
      width: 20%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
  }
  </style>

<style scoped>
.head-quarter {
      padding: 8px 0px 8px 12px !important;
  }
.wp-63 {
  width: 63%;
}
  .company-type-dropdown.multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select {
    padding-top: 0px !important;
  }
   .company-type-dropdown.multiselect-single-dropdown
  {
    width: 100%;
  }
   .company-type-dropdown.multiselect-single-dropdown >>> .multiselect__single
 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    margin-bottom: 0px;
  }
  .multiselect-single-dropdown >>> .multiselect__option:hover {
  border:1px solid #0A99ff !important;
}
.multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
  padding-top: 0px !important;
  cursor: not-allowed;
}

.multiselect-single-dropdown.multiselect--active::before{
  content: none;
}
.multiselect--active
  >>> .multiselect__tags{
    border-radius: 3px !important;
    border-bottom: none;
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
    border-top: 1px solid #CCCCCC;
    border-right: 1px solid #CCCCCC;
    border-left: 1px solid #CCCCCC;
  }
  .multiselect--active >>> .multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected.multiselect__option--highlight:after{
    content: none !important;
  }
  .multiselect--active >>> .multiselect__option--selected:after{
    content: none !important;
  }
.multiselect{
  min-height: 34px;
}
  .multiselect-single-dropdown
  >>> .multiselect__tags{
    border-radius: 3px;
    height: 34px;
    /* padding: 9px 40px 11px 11px; */
    padding: 3px 40px 6px 11px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__select{
    padding-top: 7px !important;
  }
  .multiselect-single-dropdown.multiselect--disabled >>> .multiselect__select{
    padding-top: 4px !important;
        cursor: not-allowed;
  }
  .multiselect-single-dropdown.multiselect--disabled {
        background: #ededed;
        pointer-events: none;
        opacity: 0.4;
        cursor: not-allowed;
  }
  .multiselect-single-dropdown
  >>> .multiselect__select:before{
    position: relative;
    right: 0;
    color: #4D4D4D;
    margin-top: 4px;
    border-color:  #4D4D4D transparent transparent;
    border-style: solid;
    border-width: 7px 7px 0;
    content: "";
    transform: rotate(0) !important;
    padding: 0px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__option:hover{
    background: #FFFFFF !important;
  }
  .multiselect--active
  >>> .multiselect__select{
    padding-bottom: 6px !important;
    padding-top: 4px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper .multiselect__option--highlight.multiselect__option--selected{
    border: 1px solid #0A99FF;
  }
  .multiselect-single-dropdown.multiselect--active
  >>> .multiselect__option--selected{
    background: #FFFFFF !important;
    border: 1px solid #0A99FF;
  }
  .multiselect-single-dropdown.multiselect--active
  >>> .multiselect__option--selected span{
    /* font-weight: 600 !important; */
  }
  .multiselect-single-dropdown
    >>> .multiselect__option--selected:before {
    content: none;
  }
  .multiselect--active
  >>> .multiselect__tags::after{
    content: '';
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 11px;
    right: -13px;
    border: 0.5px solid #CCCCCC !important;
    opacity:0.5;
    width: 95%;
  }
  .multiselect-single-dropdown
  >>> .multiselect__single {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    overflow: visible;
    padding-left:0px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__placeholder {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    overflow: visible;
  }
  .multiselect-single-dropdown >>> .multiselect__input::placeholder{
     color: #4D4D4D !important;
     padding-left:4px !important;
  }
.multiselect--active
  >>>  .multiselect__single,
  .multiselect--active
  >>> .multiselect__placeholder{
    padding: 4px 40px 4px 12px;
  }
 .multiselect--active
  >>> .multiselect__input{
    padding-left: 1px !important;
    padding-top: 4px !important;
    padding-bottom: 4px;
    margin-bottom: 0px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown >>> .multiselect__input{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
    padding-top: 1px !important;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content{
    margin-top: 5px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element span{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    color: #4D4D4D;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content .multiselect__element .multiselect__option{
    padding-left: 16px;
    padding-top:11px;
    padding-bottom: 10px;
    padding-right: 0px;
  }
  @media screen and (max-width: 1025px) {
    .multiselect--active
  >>> .multiselect__tags::before{
    left: 10px;
    width:94%
  }
}
.multiselect-single-dropdown.multiselect--active
>>> .multiselect__content-wrapper{
    border:1px solid #CCCCCC;
    border-top: none;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    margin-top: 0px;
    max-height: 229px !important;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .multiselect-single-dropdown
  >>> .multiselect__content-wrapper{
    -webkit-box-shadow:none;
     box-shadow: none;
  }
  .cancel_button , .save_changes_button{
    padding:10px 16px  !important
  }
  .table_data_part1{
  background-color: #FAFAFA;
}
.table_data_part2{
  background-color: #F5F5F5;
}
.regulation-data {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
  padding: 14px 0px 16px 12px !important;
}
.edit-icons{
  padding: 14px 24px 16px 12px !important;
}
  .tableHeader {
  display: flex;
  align-items: center;
  padding:14px 0px 12px 12px;
  column-gap: 7px
  /* justify-content: center; */
}
.down-arrow {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #999999;
}

.up-arrow {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #999999;
}

.regulationDataList th .arrow {
  opacity: 1;
}
.regulationDataList thead,

.regulationDataList tbody,

.regulationDataList tr:not(.regulationDataList thead tr) {
 display: table;
 width: 100%;
table-layout: fixed;
}

.regulation_table::-webkit-scrollbar {
  width: 6px;
}
.regulation_table::-webkit-scrollbar-thumb {
  background: #D9D9D9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}
.regulation_table::-webkit-scrollbar-track-piece:end {
  margin-bottom: 20px;
}
.regulation_table {
  margin-bottom: 10px;
  max-height: calc(80vh - 300px);
  overflow-y: auto;
  overflow-x: hidden;
}
   .header-line {
    border-top: 1px solid #D3D3D3;
    margin:14px 0px 26px 2px;
  }
  .custom-success-class{
    color: green;
    margin-top: 0px;
    margin-bottom: 5px;
    padding: 8px;
    font-size: 12px;
    line-height: 16px;
  }
  .action-icons{
     padding: 0px 0px 0px 18px;
  }
  .tooltip{
    z-index: 1151 !important;
  }
  .empty_data{
    padding: 10px 0;
    margin: 0;
    text-align: center;
    color: #999;
    font-size: 14px;
  }
  .mb-60 {
    margin-bottom: 60px;
  }
  .pt-22 {
    padding-top:22px;
  }
  .pt-9 {
    padding-top: 9px;
  }
  .pl-41 {
    padding-left: 41px;
  }
  .error-class {
    border: 1px solid #a20000 !important;
  }
  .headquarter{
    display: none;
  }
  .address-images {
    width:24px;
    height:24px
  }

  .ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .address-line {
    border-top: 1px solid #D3D3D3;
    margin: 0px;
    margin-bottom: 16px;
  }
  .pr-20 {
    padding-right: 20px;
  }

  .pr-8 {
      padding-right: 6px;
  }
  .pl-12 {
    padding-left: 12px;
  }
  .pl-11 {
    padding-left: 11px;
  }
  .pt-15 {
    padding-top: 15px;
  }
  .pb-14 {
    padding-bottom :14px;
  }
  .pb-12 {
    padding-bottom :12px;
  }
  .pl-9 {
    padding-left:9px
  }
  .pt-12 {
    padding-top:12px
  }
  .pt-4 {
    padding-top:4px
  }
  .pb-10 {
    padding-bottom: 9px;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  .light-blue-horizontal-line{
    border-top: 1px solid rgba(52, 17, 126, 0.1);
  }
  .arrow {
    display: inline-block;
    vertical-align: middle;
    width: 0;
    height: 0;
    margin-left: 5px;
    opacity: 1;
  }
  .arrow.asc {
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-bottom: 4px solid #B4B4B4;
  }
  .arrow.dsc {
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid #B4B4B4;
  }
  .address-header-line {
      border-bottom: 0.6px dashed #333333;
      background: none !important;
      padding: 8px 0 5px 0;
  }
  .profile-details{
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 25px;
    color: #333333;
  }
  .address-details {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    color: #3E3E3E;

  }
  .pb-15{
    padding-bottom: 15px;
  }
  .pb-20{
    padding-bottom: 20px;
  }
  .pt-20 {
    padding-top: 20px
  }
  .pl-36 {
    padding-left: 36px !important;
  }
  .pr-84{
    padding-right: 84px;
  }
  .pr-43{
    padding-right: 43px;
  }
  button[aria-expanded="true"] img.upCarret {
    display: inline-block;
  }
  button[aria-expanded="true"] img.downCarret {
    display: none;
  }
  button img.downCarret {
    display: inline-block;
    transform: rotate(180deg);
  }
  button img.upCarret {
    display: none;
  }
  .w-19 {
    width:19px;
  }
  .h-9 {
    height:9px
  }
  .address-title {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
  margin-bottom:15px;
  margin-top:2px
  }
  .file-upload-chevron {
    padding-right: 25px;
    border: none;
    background-color: transparent !important;
    /* padding-top: 20px; */
  }
  .add_address_button, .add_address_button:hover
  {
      padding: 10px 16px;
      background-color: #01518A;
      cursor: pointer;
      min-width: 172x;
      height: 44px;
      color: #ffffff;
      font-size: 18px;
      font-weight: 600;
      line-height: 25px;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
  }
  .btn-delete-address {
    background: none;

  }

  .confirmpopup-bgcolor {
    background-color: #ffffff;
    border: 0px;
    border-radius: 10px;
  }
  .modal-header .close {
    background: unset;
    opacity: 1;
    line-height: unset;
    width: unset;
    border-radius: unset;
    color: unset;
    font-weight: 300;
    font-size: 30px;
  }
  .confirm-body {
    padding: 5% 12%;
    margin-bottom: 10%;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    color: #333333;
  }
  .justify-content-end {
    justify-content: flex-end;
  }
  .profile-footer-save {
    float: right;
  }
  .profile-confirm-poup {
    width: 500px;
  }
  .modal-header.upgradeModal-bgcolor {
    background-color: #ffffff;
    border: 0px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    padding: 13px 11px 0px 19px;
  }
  .modal-footer.cancelModal-bgcolor {
    background-color: #ffffff;
    border: 0px;
    border-radius: 10px;
    padding: 0px 15px 16px 0px;
  }
  .modal-content.deactivate-acct{
    width: 493px;
  }
  .modal.deactive-modal {
    background: #00000000;
  }
  .deactive-modal .modal-dialog {
    position: fixed;
    right: -212px;
    bottom: -30px;
  }
  .required {
    color: #C02032;
  }
  .invalid-border {
    border-color: #a20000;
  }

  .warning-border {
    border-color: #f18a21;
  }
  .custom-warning-class{
    color: #f18a21;
    margin-top: 0px;
    margin-bottom: 5px;
    padding: 8px;
    font-size: 0.8em;
  }
  .form-control {
    padding: 5px 11px !important;
    border: 1px solid #4D4D4D;
    height: 34px;
    font-size: 16px;
    color: #4d4d4d;
    border-radius: 3px;
  }

  .field_css {
    margin-bottom: 36px;
  }
  .container1 {
    position: absolute;
    left: 0px;
    right: 0px;
    display: flex;
    flex-direction: column;
    max-height: calc(84vh - 404px);
  }
  .section {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }
  .scrollable-content {
    flex-grow: 1;
    overflow: auto;
    overflow-x: hidden;
    min-height: 0;
  }

  .body::-webkit-scrollbar {
    width: 6px;
  }
  .body::-webkit-scrollbar-thumb {
    background: #D9D9D9;
    border-top-left-radius: 18px;
    border-bottom-left-radius: 18px;
  }

  .input_number {
    text-align: center;
  }
  .preference_popover_txt {
    text-align: left;
    word-break: break-word;
  }
  .alert_text {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    vertical-align: bottom;
    color: rgba(0, 0, 0, 0.7) !important;
  }
  .info-img {
    height: 18px;
    width: 18px;
    margin-left: 6px;
  }
  .prd-dtls-pd {
    padding: 10px 0px 0px 0px;
  }
  .header-team {
    padding: 15px 0px 0px 0px;
    font-size: 28px;
    line-height: 33px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 300;
  }
  .icon-close {
    color: #333333 !important;
  }
  .managePreparencePopup .v-select .dropdown-toggle {
    background-image: none;
  }
  .add-border {
    width: 100%;
    border: 0.5px solid #828282;
    box-sizing: border-box;
    border-radius: 20px;
  }
  .subHeader {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    color: #0b3c61;
    margin-top: 10px;
    margin-bottom: 15px;
  }
  .popup-close {
    float: right;
  }
  .body {
    /* margin-bottom: 10px; */
    /* max-height: calc(80vh - 142px);
    overflow-y: auto;
    overflow-x: hidden; */
  }
  .pd-lt-0 {
    padding-left: 0px;
  }
  .pl-2{
     padding-left: 2px;
  }
  .pd-rt-0 {
    padding-right: 0px;
  }
  .text-alg-center {
    text-align: center;
  }
  .member-box-wrapper {
    padding-top: 5px;
    padding-bottom: 5px;
    border-bottom: 0.5px solid #bdbdbd;
  }
  /** newcss */
  .expiry-status-desc {
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: rgba(0, 0, 0, 0.7);
    padding: 15px;
  }
  .heading {
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: rgba(0, 0, 0, 0.7);
  }
  .mb-10 {
    margin-bottom: -10px;
  }
  .mb-5 {
    margin-bottom: -5px;
  }
  .pr-44 {
    padding-right:44px !important
  }
  .wordbreak {
    word-break: break-all;
  }
  .pd-top-6 {
    padding-top: 6px;
  }
  .elTabs >>> .el-tabs__header {
    margin-bottom: 15px;
  }
  .elTabs >>> .el-tabs__item {
    font-size: 16px;
  }
  .elTabs >>> .el-tabs__nav-wrap {
    width: 98%;
  }
  .mobile-heading {
    display: none;
  }
  .el-select {
    display: block!important;
  }
  .el-select-dropdown__item {
    color: #3E3E3E;
  }

  .el-select-dropdown__item.selected {
    color: #3E3E3E;
  }
  .footer {
    padding: 10px 24px 24px 24px;
    position: absolute;
    bottom: 0%;
    right: 0;
  }

  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
     opacity: 1;
  }
  /* @media screen and (max-width: 1024px) {
    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
      width: 20%;
      pointer-events: auto;
    }
  }
  @media (device-width:1366px) and (device-height: 1024px) {
    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
      width: 20%;
      pointer-events: auto;
    }
  }
  @media screen and (max-width: 767px) {
    .months_bef_wrapper {
      padding-left: 12px;
      line-height: 0px;
    }
    .custom-dropdown {
      margin-top: 5px;
    }
    .xs-pd-tp-0 {
      padding-top: 0px;
    }
    .expiry-status-desc {
      padding-bottom: 5px;
    }
    .pd-top-6 {
      padding-top: 0px;
    }
    .mobile-heading {
      display: block;
      font-size: 13px;
      font-weight: 500;
    }
    .heading {
      font-size: 13px;
    }
    .hideHeading {
      display: none;
    }
    .xs-pd-0 {
      padding: 0px;
    }
    .xs-pd-lt-5 {
      padding-left: 5px;
    }
    .xs-pd-6 {
      padding: 6px;
    }
    .xs-pd-rt-0 {
      padding-right: 0px;
    }
    .xs-pd-lt-0 {
      padding-left: 0px;
    }
    .footer {
      padding-bottom: 5%;
    }
  } */
  /* @media (min-width: 321px) and (max-width: 767px) {
    .container1 {
      max-height: calc(84vh - 435px);
    }
  }
  @media screen and (max-width: 1023px) {
    .hide_sm_xs {
      display: none;
    }
  }
  @media (width: 1024px) and (height: 768px){
    .container1 {
      max-height: calc(84vh - 550px);
    }
  }
  @media screen and (width: 768px) {
    .container1 {
      max-height: calc(84vh - 610px);
    }
    .body {
      max-height: calc(80vh - 142px);
    }
  }
  @media (min-width: 769px)  and (max-width: 1024px) {
    .body {
      height: 80Vh;
      overflow-y: scroll;
    }
  } */
  /* @media (min-width: 1025px) and (max-width: 1280px) {
    .form-control {
        padding: 0px;
    }
    .mt-5{
      margin-top: 5px;
    }
  } */
  /* @media only screen and (max-width: 320px) {
    .body {
      height: 60Vh;
      overflow-y: scroll;
    }
    .container1 {
      max-height: 100%;
    }
  } */
  /* iphoneX landscape  */
  /* @media (device-width: 812px) and (device-height: 375px){
    .body {
      height: 46Vh;
      overflow-y: scroll;
    }
    .container1 {
      max-height: 100%;
    }
  } */
  /* iphone5 landscape and below */
  /* @media (max-width: 640px) and (max-height: 360px){
    .body {
      height: 33Vh;
      overflow-y: scroll;
    }
    .container1 {
      max-height: 100%;
    }
  } */
  /* iphone 6 and 6+ landscape  */
  /* @media (device-width: 736px) and (device-height: 414px), (device-width: 667px) and (device-height: 375px){
    .body {
      height: 44Vh;
      overflow-y: scroll;
    }
    .container1 {
      max-height: 100%;
    }
  } */

  /* @media (max-width: 1300px) {
    .ml-266 {
      margin-left: 10px;
    }
  } */
  </style>
